export default "__VITE_PUBLIC_ASSET__20177915__"